import { Checkbox as AntdCheckbox } from 'antd'
import React from 'react'
import styled from 'styled-components'

const StyledCheckbox = styled(AntdCheckbox)`
  .ant-checkbox + span {
    padding-left: 12px;
  }
`
const LabelWrapper = styled.div`
  font-size: ${props =>
    props.size ? props.size : '16px'}
  line-height: 24px;
  color: #202020;
`

const Checkbox = ({ onChange, label, value, size=null, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} value={value}>
      <LabelWrapper size={size}>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default Checkbox
